export enum GlobalComponent {
  NAVIGATION = 'NAVIGATION',
  FOOTER = 'FOOTER',
}
